import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, I } from '../system/icons';
import { inputBase } from '../system/inputBase';
export function Select({ options, placeholder, style, defaultValue, value, ...rest }) {
    // Controlled-vs-uncontrolled: only thread `defaultValue` when no `value`
    // prop was supplied. The previous unconditional `defaultValue ?? ''` paired
    // with `value` from the parent triggered React's "Select elements must be
    // either controlled or uncontrolled" warning and pre-selected the disabled
    // placeholder option even when the parent had a real selection.
    const isControlled = value !== undefined;
    return (_jsxs("div", { style: { position: 'relative' }, children: [_jsxs("select", { ...(isControlled
                    ? { value }
                    : { defaultValue: defaultValue ?? '' }), style: {
                    ...inputBase,
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    paddingRight: 'var(--space-2xl)',
                    cursor: 'pointer',
                    ...style,
                }, ...rest, children: [placeholder && _jsx("option", { value: "", disabled: true, children: placeholder }), options.map(o => typeof o === 'string'
                        ? _jsx("option", { value: o, children: o }, o)
                        : _jsx("option", { value: o.value, children: o.label }, o.value))] }), _jsx("div", { style: {
                    position: 'absolute',
                    right: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                    color: 'var(--muted-foreground)',
                }, children: _jsx(Icon, { size: 16, children: I.arrowDown }) })] }));
}
//# sourceMappingURL=Select.js.map